module.exports = __webpack_public_path__ + "static/media/ravifruitLogo.498c02f5.jpg";